import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import { useSelector } from 'react-redux';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { useAppDispatch } from '../../reducers';
import { setActiveCustomerCurrencyCode } from '../../actions/CurrencyCodeActions';
import { activeCurrencySelector, availableCurrenciesSelector } from '../../selectors/CurrencySelectors';
import UISelect from 'UIComponents/input/UISelect';

const CurrencyPicker = () => {
  const dispatch = useAppDispatch();

  const handleChange = ({
    target: {
      value: currency
    }
  }) => {
    dispatch(setActiveCustomerCurrencyCode(currency));
    getUsageTracker().track('selectCurrency', {
      currency
    });
  };

  const availableCurrencies = useSelector(availableCurrenciesSelector);

  const getCurrencyOptions = () => availableCurrencies.map(availableCurrency => ({
    text: `${availableCurrency} (${I18n.currencySymbols[availableCurrency].symbol})`,
    value: availableCurrency
  }));

  const activeCurrencyCode = useSelector(activeCurrencySelector);
  const shouldShowSelector = availableCurrencies && availableCurrencies.length > 1;

  if (!shouldShowSelector) {
    return /*#__PURE__*/_jsx("span", {
      style: {
        minHeight: '40px'
      }
    });
  }

  return /*#__PURE__*/_jsx(UISelect, {
    buttonUse: "transparent",
    menuWidth: 200,
    menuStyle: {
      minHeight: 320
    },
    className: "display-inline-block",
    options: getCurrencyOptions(),
    onChange: handleChange,
    value: activeCurrencyCode,
    "data-selenium-id": "currency-picker"
  });
};

export default CurrencyPicker;